import React, { useContext } from 'react';
import { IGamesContext, GamesContext } from '../../../gamesState/gamesContext';
import Text from 'components/Text/Text';
import { Checkbox } from 'antd';
import style from './UnassignedGamesCheckBox.module.scss';

const UnassignedGamesCheckBox: React.FC = () => {
	const { toggleUnassignedGames, isUnassignedGames } = useContext<IGamesContext>(GamesContext);

	return (
		<Checkbox
			className={style.container}
			onChange={toggleUnassignedGames}
			checked={isUnassignedGames}
			data-test="UnassignedGamesCheckBox">
			<Text translationNameSpace="listing" translationKey="unassignedGamesLabel" asFragment={true} />
		</Checkbox>
	);
};

export default UnassignedGamesCheckBox;
